import bigdefApiFunctions from 'alp-shared-components/dist/api/bigdef';

import setupAxios from './setup-axios';
import { fetchCookies } from '../utils';

export default function BigdefAPI() {
  const axiosConfig = {
    baseURL: process.env.BIGDEF_API_URL
  };

  const axios = setupAxios(axiosConfig);

  axios.interceptors.request.use(
    (config) => {
      const token = fetchCookies('bigdef_token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  return bigdefApiFunctions(axios);
}
